<template>
  <!-- 绿色低碳 -->
  <div>
    <div class="sign-content">
      <el-card-title :title="title" />
      <el-form label-width="80px" :model="cooperationForm" :rules="cooperationFormRules" ref="cooperationFormRef">
        <!-- /* 企业是否设计绿色低碳管理：0 - 否；1 - 是 */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenLowCarbon')" label-width="420px"
          prop="greenCarbonManageFlag">
          <!-- 本企业是否涉及绿色低碳管理 -->
          <el-radio-group v-model="cooperationForm.greenCarbonManageFlag" :disabled="isGAT">
            <el-radio label="1">{{
              $t("page.greenLowCarbon.contentLabel.isYes")
              }}</el-radio>
            <el-radio label="0">{{
              $t("page.greenLowCarbon.contentLabel.isNo")
              }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--     /* 绿色低碳类型：1 - 不选择；2 - 水泥；3 - 钢材；4 - 沥青 */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.changeCategory')" label-width="420px"
          v-if="cooperationForm.greenCarbonManageFlag == '1'" prop="greenCarbonType">
          <!-- 请选择类别 -->
          <el-select v-model="cooperationForm.greenCarbonType" clearable :placeholder="$t('page.greenLowCarbon.contentLabel.changeCategoryPlaceholder')
            " @change="handleGreenCarbonTypeChange">
            <el-option v-for="(item, index) in changeCategoryOption" :key="index" :label="item.dictName"
              :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="cooperationForm.greenCarbonManageFlag == '1'">
          <el-card-title :title="title1" />
          <!-- /* 是否获得绿色工厂认证（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenProduction')" label-width="420px"
            :aria-hidden="false" prop="greenFactoryFlag">
            <!-- 是否获得绿色工厂认证 -->
            <el-radio-group v-model="cooperationForm.greenFactoryFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--  /* 绿色工厂认证级别：7 - 市级；8 - 省级；9 - 国家级 */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.greenFactoryCertificationLevel'
          )
            " label-width="420px" v-if="cooperationForm.greenFactoryFlag == '1'" prop="greenFactoryLevel">
            <!-- 绿色工厂认证等级 -->
            <el-select v-model="cooperationForm.greenFactoryLevel" clearable :placeholder="$t(
              'page.greenLowCarbon.contentLabel.greenFactoryCertificationLevelPlaceholder'
            )
              ">
              <el-option v-for="(item, index) in greenFactoryCertificationLevelOption" :key="index"
                :label="item.dictName" :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <!-- /* 绿色工厂认证证书 */  greenFactoryFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.greenFactoryCertificationFile'
          )
            " label-width="420px" v-if="cooperationForm.greenFactoryFlag == '1'" prop="greenFactoryFiles">
            <!-- 上传对应的【绿色工厂认证证书/铭牌】附件 -->
            <!-- 绿色工厂上传 -->
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.greenFactoryFiles" :on-progress="e => onProgress(e, 'green')" :on-change="(file, fileList) => handleFileChange(file, fileList, 'green')
                " multiple accept=".png,.jpg,.jpeg,.gif,.webp,.pdf,"
              :before-upload="file => beforeAvatarUpload(file, 'green')" :on-success="res => onSuccess(res, 'green')"
              :on-error="(err, file, fileList) => onError(err, file, fileList, 'green')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>

            <!-- 自定义文件列表表格 - 绿色工厂 -->
            <el-table v-if="cooperationForm.greenFactoryFiles.length > 0" :data="cooperationForm.greenFactoryFiles"
              style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'green')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="deleteFile(scope.$index, 'green')">{{
                    $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <!-- /* 是否获得零碳工厂认证（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isZeroCarbonFactoryCertification'
          )
            " label-width="420px" prop="zeroFactoryFlag">
            <!-- 是否获得零碳工厂认证 -->
            <el-radio-group v-model="cooperationForm.zeroFactoryFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--   /* 零碳工厂认证级别：3 - 三星；4 - 四星；5 - 五星；6 - 六星 */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isZeroCarbonFactoryCertificationRating'
          )
            " label-width="420px" v-if="cooperationForm.zeroFactoryFlag == '1'" prop="zeroFactoryLevel">
            <!-- 零碳工厂认证等级 -->
            <el-select v-model="cooperationForm.zeroFactoryLevel" clearable :placeholder="$t(
              'page.greenLowCarbon.contentLabel.isZeroCarbonFactoryCertificationRatingPlaceholder'
            )
              ">
              <el-option v-for="(item,
                index) in zeroCarbonFactoryCertificationRatingOption" :key="index" :label="item.dictName"
                :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <!-- /* 零碳工厂认证证书 */ zeroFactoryFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.ZeroCarbonFactoryCertificationRatingFile'
          )
            " label-width="420px" v-if="cooperationForm.zeroFactoryFlag == '1'" prop="zeroFactoryFiles">
            <!-- 上传对应的【零碳工厂认证证书/铭牌】附件 -->
            <!-- 零碳工厂上传 -->
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.zeroFactoryFiles" :on-progress="e => onProgress(e, 'zero')" :on-change="(file, fileList) => handleFileChange(file, fileList, 'zero')
                " multiple accept=".png,.jpg,.jpeg,.gif,.webp,.pdf,"
              :before-upload="file => beforeAvatarUpload(file, 'zero')" :on-success="res => onSuccess(res, 'zero')"
              :on-error="(err, file, fileList) => onError(err, file, fileList, 'zero')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>
            <!-- 上传 -->

            <!-- 自定义文件列表表格 - 零碳工厂 -->
            <el-table v-if="cooperationForm.zeroFactoryFiles.length > 0" :data="cooperationForm.zeroFactoryFiles"
              style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'zero')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="deleteFile(scope.$index, 'zero')">{{
                    $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <!-- /* 是否通过企业清洁生产审核（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isEnterprisesPassTheCleanProductionAudit'
          )
            " label-width="420px" prop="cleanProductionFlag">
            <!-- 是否通过企业清洁生产审核 -->
            <el-radio-group v-model="cooperationForm.cleanProductionFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--  /* 清洁生产审核报告（备案本） */ cleanProductionFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.EnterprisesPassTheCleanProductionAuditFile'
          )
            " label-width="420px" v-if="cooperationForm.cleanProductionFlag == '1'" prop="cleanProductionFiles">
            <!-- 上传的【清洁生产审核报告（备案本）】附件 -->
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.cleanProductionFiles" :on-progress="e => onProgress(e, 'clean')" :on-change="(file, fileList) => handleFileChange(file, fileList, 'clean')
                " multiple accept=".png,.jpg,.jpeg,.gif,.webp,.pdf,"
              :before-upload="file => beforeAvatarUpload(file, 'clean')" :on-success="res => onSuccess(res, 'clean')"
              :on-error="(err, file, fileList) => onError(err, file, fileList, 'clean')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>
            <!-- 上传 -->
            <!-- 自定义文件列表表格 - 清洁生产 -->
            <el-table v-if="cooperationForm.cleanProductionFiles.length > 0"
              :data="cooperationForm.cleanProductionFiles" style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'clean')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="deleteFile(scope.$index, 'clean')">{{
                    $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <!-- 类别为水泥 新增以下选项 -->
          <template v-if="cooperationForm.greenCarbonType == '2'">
            <!-- /* 水泥 - 是否使用新型干法等环保性生产工艺（1 - 是/0 - 否） */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.isEnvironmentallyFriendlyProductionProcess'
            )
              " label-width="420px" prop="cementCraftFlag">
              <!-- 是否使用新型干法等环保性生产工艺 -->
              <el-radio-group v-model="cooperationForm.cementCraftFlag">
                <el-radio label="1">{{
                  $t("page.greenLowCarbon.contentLabel.isYes")
                  }}</el-radio>
                <el-radio label="0">{{
                  $t("page.greenLowCarbon.contentLabel.isNo")
                  }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!--/* 是否使用新型干法（附件） */ cementCraftFiles -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.EnvironmentallyFriendlyProductionProcessFile'
            )
              " label-width="420px" v-if="cooperationForm.cementCraftFlag == '1'" prop="cementCraftFiles">
              <!-- 上传对应的【生产工艺设计说明/流程说明】附件 -->
              <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
                :file-list="cooperationForm.cementCraftFiles" :on-progress="e => onProgress(e, 'production')"
                :on-change="(file, fileList) =>
                    handleFileChange(file, fileList, 'production')
                  " multiple accept=".pdf,.doc,.docx,.xls,.xlsx"
                :before-upload="file => beforeAvatarUpload(file, 'production')"
                :on-success="res => onSuccess(res, 'production')" :on-error="(err, file, fileList) =>
                    onError(err, file, fileList, 'production')
                  ">
                <el-button type="text" @click="getIndex()">{{
                  $t("page.qualificationFile.btn.uploading")
                  }}</el-button>
              </el-upload>
              <!-- 上传 -->
              <!-- 自定义文件列表表格 - 清洁生产 -->
              <el-table v-if="cooperationForm.cementCraftFiles.length > 0" :data="cooperationForm.cementCraftFiles"
                style="width: 100%; margin-top: 10px" border>
                <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
                <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
                <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewFile(scope.row, 'production')">{{
                      $t("page.greenLowCarbon.table.preview") }}</el-button>
                      <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                    <el-button type="text" @click="deleteFile(scope.$index, 'production')">{{
                      $t("page.greenLowCarbon.table.delete") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>

          <!-- 类别为钢筋 新增以下选项 -->
          <template v-if="cooperationForm.greenCarbonType == '3'">
            <!-- /* 钢材 - 单位产品能源消耗量 */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.isProductEnergyConsumption'
            )
              " label-width="420px" prop="steelEnergyConsumptionValue">
              <!-- 轧钢单位产品能源消耗量 -->
              <el-input v-model="cooperationForm.steelEnergyConsumptionValue" :placeholder="$t(
                'page.greenLowCarbon.contentLabel.isProductEnergyConsumptionPlaceholder'
              )
                " style="width: 200px;"></el-input><span>kgce/t</span>
            </el-form-item>
            <!-- /* 钢材 - 单位产品能源消耗量（附件） */ steelEnergyConsumptionFiles -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.ProductEnergyConsumptionFile'
            )
              " label-width="420px" prop="steelEnergyConsumptionFiles">
              <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
                :file-list="cooperationForm.steelEnergyConsumptionFiles" :on-progress="e => onProgress(e, 'energy')"
                :on-change="(file, fileList) => handleFileChange(file, fileList, 'energy')
                  " multiple accept=".png,.jpg,.pdf,.doc,.docx"
                :before-upload="file => beforeAvatarUpload(file, 'energy')"
                :on-success="res => onSuccess(res, 'energy')" :on-error="(err, file, fileList) =>
                    onError(err, file, fileList, 'energy')
                  ">
                <el-button type="text" @click="getIndex()">{{
                  $t("page.qualificationFile.btn.uploading")
                  }}</el-button>
              </el-upload>
              <!-- 上传 -->
              <!-- 自定义文件列表表格 - 清洁生产 -->
              <el-table v-if="cooperationForm.steelEnergyConsumptionFiles.length > 0"
                :data="cooperationForm.steelEnergyConsumptionFiles" style="width: 100%; margin-top: 10px" border>
                <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
                <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
                <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewFile(scope.row, 'energy')">{{
                      $t("page.greenLowCarbon.table.preview") }}</el-button>
                      <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                    <el-button type="text" @click="deleteFile(scope.$index, 'energy')">{{
                      $t("page.greenLowCarbon.table.delete") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>

          <!-- 类别为沥青 新增以下选项 -->
          <template v-if="cooperationForm.greenCarbonType == '4'">
            <!--  /* 沥青 - 单位产品能源消耗量 */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.isAsphaltProductEnergyConsumption'
            )
              " label-width="420px" prop="asphaltEnergyConsumptionValue">
              <!-- 轧钢单位产品能源消耗量 -->
              <el-input v-model="cooperationForm.asphaltEnergyConsumptionValue" :placeholder="$t(
                'page.greenLowCarbon.contentLabel.isAsphaltProductEnergyConsumptionPlaceholder'
              )
                " style="width: 200px;"></el-input><span>kgce/t</span>
            </el-form-item>
            <!--/* 沥青 - 单位产品能源消耗量（附件） */ asphaltEnergyConsumptionFiles -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.AsphaltProductEnergyConsumptionFile'
            )
              " label-width="420px" prop="asphaltEnergyConsumptionFiles">
              <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
                :file-list="cooperationForm.asphaltEnergyConsumptionFiles" :on-progress="e => onProgress(e, 'Asphalt')"
                :on-change="(file, fileList) =>
                    handleFileChange(file, fileList, 'Asphalt')
                  " multiple accept=".pdf,.doc,.docx" :before-upload="file => beforeAvatarUpload(file, 'Asphalt')"
                :on-success="res => onSuccess(res, 'Asphalt')" :on-error="(err, file, fileList) =>
                    onError(err, file, fileList, 'Asphalt')
                  ">
                <el-button type="text" @click="getIndex()">{{
                  $t("page.qualificationFile.btn.uploading")
                  }}</el-button>
              </el-upload>
              <!-- 上传 -->
              <!-- 自定义文件列表表格 - 清洁生产 -->
              <el-table v-if="cooperationForm.asphaltEnergyConsumptionFiles.length > 0"
                :data="cooperationForm.asphaltEnergyConsumptionFiles" style="width: 100%; margin-top: 10px" border>
                <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
                <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
                <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewFile(scope.row, 'Asphalt')">{{
                      $t("page.greenLowCarbon.table.preview") }}</el-button>
                      <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                    <el-button type="text" @click="deleteFile(scope.$index, 'Asphalt')">{{
                      $t("page.greenLowCarbon.table.delete") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>

          <!-- 绿色产品 -->
          <el-card-title :title="title2" />
          <addGreenProducts @handleGreenProduct="handleGreenProduct" :temGreenInfo="temGreenInfo" :greenCarbonType="cooperationForm.greenCarbonType"></addGreenProducts>

          <!-- 类别为水泥 新增以下选项 -->
          <template v-if="cooperationForm.greenCarbonType == '2'">
            <!-- /* 水泥 - 是否采用原材料替代等资源循环利用方式（1 - 是/0 - 否） */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.AdoptingMethodsOfResourceRecyclingSuchAsRawMaterialSubstitution'
            )
              " label-width="420px" prop="cementRecyclingFlag">
              <el-radio-group v-model="cooperationForm.cementRecyclingFlag">
                <el-radio label="1">{{
                  $t("page.greenLowCarbon.contentLabel.isYes")
                  }}</el-radio>
                <el-radio label="0">{{
                  $t("page.greenLowCarbon.contentLabel.isNo")
                  }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!--  /* 水泥 - 原材料替代率（百分比） */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.RawMaterialSubstitutionRate'
            )
              " v-if="cooperationForm.cementRecyclingFlag == '1'" label-width="420px" prop="cementRecyclingValue">
              <el-input v-model="cooperationForm.cementRecyclingValue" :placeholder="$t(
                'page.greenLowCarbon.contentLabel.RawMaterialSubstitutionRatePlaceholder'
              )
                " style="width: 200px;"></el-input><span>%</span>
            </el-form-item>
            <!-- /* 水泥 - 原材料替代率（附件） */ cementRecyclingFiles -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.productionRawMaterialSubstitutionRate'
            )
              " label-width="420px" v-if="cooperationForm.cementRecyclingFlag == '1'" prop="cementRecyclingFiles">
              <!-- 上传对应的【生产原料替代率计算书】附件 -->
              <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
                :file-list="cooperationForm.cementRecyclingFiles" :on-progress="e => onProgress(e, 'Calculation')"
                :on-change="(file, fileList) =>
                    handleFileChange(file, fileList, 'Calculation')
                  " multiple accept=".pdf,.doc,.docx" :before-upload="file => beforeAvatarUpload(file, 'Calculation')"
                :on-success="res => onSuccess(res, 'Calculation')" :on-error="(err, file, fileList) =>
                    onError(err, file, fileList, 'Calculation')
                  ">
                <el-button type="text" @click="getIndex()">{{
                  $t("page.qualificationFile.btn.uploading")
                  }}</el-button>
              </el-upload>
              <!-- 上传 -->
              <!-- 自定义文件列表表格 - 清洁生产 -->
              <el-table v-if="cooperationForm.cementRecyclingFiles.length > 0"
                :data="cooperationForm.cementRecyclingFiles" style="width: 100%; margin-top: 10px" border>
                <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
                <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
                <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewFile(scope.row, 'Calculation')">{{
                      $t("page.greenLowCarbon.table.preview") }}</el-button>
                      <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                    <el-button type="text" @click="deleteFile(scope.$index, 'Calculation')">{{
                      $t("page.greenLowCarbon.table.delete") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>

          <!-- 类别为钢筋 新增以下选项 -->
          <template v-if="cooperationForm.greenCarbonType == '3'">
            <!-- /* 钢材 - 是否对轧钢过程进行废钢余料回收再利用（1 - 是/0 - 否） */ -->
            <el-form-item :label="$t('page.greenLowCarbon.contentLabel.steelRollingProcess')
              " label-width="420px" prop="steelRecyclingFlag">
              <el-radio-group v-model="cooperationForm.steelRecyclingFlag">
                <el-radio label="1">{{
                  $t("page.greenLowCarbon.contentLabel.isYes")
                  }}</el-radio>
                <el-radio label="0">{{
                  $t("page.greenLowCarbon.contentLabel.isNo")
                  }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- /* 钢材 - 是否对轧钢过程进行废钢余料回收再利用（附件） */steelRecyclingFiles -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.ScrapSteelRecyclingPlanFile'
            )
              " label-width="420px" v-if="cooperationForm.steelRecyclingFlag == '1'"
              prop="steelRecyclingFiles">
              <!-- 上传对应的【生产原料替代率计算书】附件 -->
              <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
                :file-list="cooperationForm.steelRecyclingFiles"
                :on-progress="e => onProgress(e, 'steelRollingProcess')" :on-change="(file, fileList) =>
                    handleFileChange(file, fileList, 'steelRollingProcess')
                  " multiple accept=".pdf,.doc,.docx" :before-upload="file => beforeAvatarUpload(file, 'steelRollingProcess')
                  " :on-success="res => onSuccess(res, 'steelRollingProcess')" :on-error="(err, file, fileList) =>
                    onError(err, file, fileList, 'steelRollingProcess')
                  ">
                <el-button type="text" @click="getIndex()">{{
                  $t("page.qualificationFile.btn.uploading")
                  }}</el-button>
              </el-upload>
              <!-- 上传 -->
              <!-- 自定义文件列表表格 - 清洁生产 -->
              <el-table v-if="cooperationForm.steelRecyclingFiles.length > 0"
                :data="cooperationForm.steelRecyclingFiles" style="width: 100%; margin-top: 10px" border>
                <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
                <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
                <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewFile(scope.row, 'steelRollingProcess')">{{
                      $t("page.greenLowCarbon.table.preview") }}</el-button>
                      <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                    <el-button type="text" @click="deleteFile(scope.$index, 'steelRollingProcess')">{{
                      $t("page.greenLowCarbon.table.delete") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>

          <!-- 类别为沥青 新增以下选项 -->
          <template v-if="cooperationForm.greenCarbonType == '4'">
            <!-- /* 沥青 - 是否对沥青生产原材料进行回收利用（1 - 是/0 - 否） */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.IsRecyclingOfRawMaterialsForAsphaltProductionConducted'
            )
              " label-width="420px" prop="asphaltRecyclingFlag">
              <el-radio-group v-model="cooperationForm.asphaltRecyclingFlag">
                <el-radio label="1">{{
                  $t("page.greenLowCarbon.contentLabel.isYes")
                  }}</el-radio>
                <el-radio label="0">{{
                  $t("page.greenLowCarbon.contentLabel.isNo")
                  }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- /* 沥青 - 原材料回收利用率（百分比） */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.RawMaterialRecyclingAndUtilizationRate'
            )
              " v-if="cooperationForm.asphaltRecyclingFlag == '1'" label-width="420px" prop="asphaltRecyclingValue">
              <!-- 轧钢单位产品能源消耗量 -->
              <el-input v-model="cooperationForm.asphaltRecyclingValue" :placeholder="$t(
                'page.greenLowCarbon.contentLabel.RawMaterialRecyclingAndUtilizationRatePlaceholder'
              )
                " style="width: 200px;"></el-input><span>%</span>
            </el-form-item>
            <!-- /* 沥青 - 原材料回收利用率（附件） */asphaltRecyclingFiles -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.CalculationSheetForRawMaterialRecyclingUtilizationRate'
            )
              " label-width="420px" v-if="cooperationForm.asphaltRecyclingFlag == '1'" prop="asphaltRecyclingFiles">
              <!-- 上传对应的【生产原料替代率计算书】附件 -->
              <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
                :file-list="cooperationForm.asphaltRecyclingFiles" :on-progress="e => onProgress(e, 'CalculationSheet')"
                :on-change="(file, fileList) =>
                    handleFileChange(file, fileList, 'CalculationSheet')
                  " multiple accept=".pdf,.doc,.docx" :before-upload="file => beforeAvatarUpload(file, 'CalculationSheet')
                  " :on-success="res => onSuccess(res, 'CalculationSheet')" :on-error="(err, file, fileList) =>
                    onError(err, file, fileList, 'CalculationSheet')
                  ">
                <el-button type="text" @click="getIndex()">{{
                  $t("page.qualificationFile.btn.uploading")
                  }}</el-button>
              </el-upload>
              <!-- 上传 -->
              <!-- 自定义文件列表表格 - 清洁生产 -->
              <el-table v-if="cooperationForm.asphaltRecyclingFiles.length > 0"
                :data="cooperationForm.asphaltRecyclingFiles" style="width: 100%; margin-top: 10px" border>
                <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
                <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
                <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewFile(scope.row, 'CalculationSheet')">{{
                      $t("page.greenLowCarbon.table.preview") }}</el-button>
                      <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                    <el-button type="text" @click="deleteFile(scope.$index, 'CalculationSheet')">{{
                      $t("page.greenLowCarbon.table.delete") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <!-- /* 沥青 - 是否对废沥青生产原材料进行回收利用（1 - 是/0 - 否） */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.IsWasteAsphaltRecycledAndReused'
            )
              " label-width="420px" prop="asphaltWasteRecyclingFlag">
              <!-- 是否使用新型干法等环保性生产工艺 -->
              <el-radio-group v-model="cooperationForm.asphaltWasteRecyclingFlag">
                <el-radio label="1">{{
                  $t("page.greenLowCarbon.contentLabel.isYes")
                  }}</el-radio>
                <el-radio label="0">{{
                  $t("page.greenLowCarbon.contentLabel.isNo")
                  }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- /* 沥青 - 废沥青回收利用率（百分比） */ -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.RecyclingRateOfWasteAsphalt'
            ) " v-if="cooperationForm.asphaltWasteRecyclingFlag == '1'"
               label-width="420px" prop="asphaltWasteRecyclingValue">
              <!-- 轧钢单位产品能源消耗量 -->
              <el-input v-model="cooperationForm.asphaltWasteRecyclingValue" :placeholder="$t(
                'page.greenLowCarbon.contentLabel.RecyclingRateOfWasteAsphaltPlaceholder'
              )
                " style="width: 200px;"></el-input><span>%</span>
            </el-form-item>
            <!-- /* 沥青 - 原材料回收利用率（附件） */ asphaltWasteRecyclingFiles -->
            <el-form-item :label="$t(
              'page.greenLowCarbon.contentLabel.recyclingTaxRefundSupportingDocuments'
            )
              " label-width="420px" v-if="cooperationForm.asphaltWasteRecyclingFlag == '1'"
              prop="asphaltWasteRecyclingFiles">
              <!-- 上传对应的【生产原料替代率计算书】附件 -->
              <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
                :file-list="cooperationForm.asphaltWasteRecyclingFiles"
                :on-progress="e => onProgress(e, 'recyclingTax')" :on-change="(file, fileList) =>
                    handleFileChange(file, fileList, 'recyclingTax')
                  " multiple accept=".pdf,.doc,.docx" :before-upload="file => beforeAvatarUpload(file, 'recyclingTax')
                  " :on-success="res => onSuccess(res, 'recyclingTax')" :on-error="(err, file, fileList) =>
                    onError(err, file, fileList, 'recyclingTax')
                  ">
                <el-button type="text" @click="getIndex()">{{
                  $t("page.qualificationFile.btn.uploading")
                  }}</el-button>
              </el-upload>
              <!-- 上传 -->
              <!-- 自定义文件列表表格 - 清洁生产 -->
              <el-table v-if="cooperationForm.asphaltWasteRecyclingFiles.length > 0"
                :data="cooperationForm.asphaltWasteRecyclingFiles" style="width: 100%; margin-top: 10px" border>
                <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
                <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
                <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewFile(scope.row, 'recyclingTax')">{{
                      $t("page.greenLowCarbon.table.preview") }}</el-button>
                      <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                    <el-button type="text" @click="deleteFile(scope.$index, 'recyclingTax')">{{
                      $t("page.greenLowCarbon.table.delete") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>

          <!-- 绿色物流 -->
          <el-card-title :title="title3" />
          <!-- /* 是否获得绿色物流认证（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenLogistics')" label-width="420px"
            prop="logisticsCertificationFlag">
            <!-- 是否获得绿色物流认证 -->
            <el-radio-group v-model="cooperationForm.logisticsCertificationFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- /* 绿色物流认证级别：1 - 一星；2 - 二星；3 - 三星 */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenProductionRating')
            " label-width="420px" v-if="cooperationForm.logisticsCertificationFlag == '1'"
            prop="logisticsCertificationLevel">
            <el-select v-model="cooperationForm.logisticsCertificationLevel" clearable :placeholder="$t(
              'page.greenLowCarbon.contentLabel.isGreenProductionRatingPlaceholder'
            )
              ">
              <el-option v-for="(item, index) in logisticsCertificationLevelOption" :key="index" :label="item.dictName"
                :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <!--/* 绿色物流认证级别（附件） */ logisticsCertificationFiles -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.greenLogisticsFile')" label-width="420px"
            v-if="cooperationForm.logisticsCertificationFlag == '1'" prop="logisticsCertificationFiles">
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.logisticsCertificationFiles"
              :on-progress="e => onProgress(e, 'greenLogisticsFile')" :on-change="(file, fileList) =>
                  handleFileChange(file, fileList, 'greenLogisticsFile')
                " multiple accept=".png,.jpg,.jpeg,.gif,.webp,.pdf," :before-upload="file => beforeAvatarUpload(file, 'greenLogisticsFile')
                " :on-success="res => onSuccess(res, 'greenLogisticsFile')" :on-error="(err, file, fileList) =>
                  onError(err, file, fileList, 'greenLogisticsFile')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>

            <!-- 自定义文件列表表格 - 绿色工厂 -->
            <el-table v-if="cooperationForm.logisticsCertificationFiles.length > 0"
              :data="cooperationForm.logisticsCertificationFiles" style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'greenLogisticsFile')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="deleteFile(scope.$index, 'greenLogisticsFile')">{{
                    $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <!-- /* 是否使用了智能仓储管理技术（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isSmartWarehouse')" label-width="420px"
            prop="smartWarehouseFlag">
            <!-- 是否Smart Warehouse -->
            <el-radio-group v-model="cooperationForm.smartWarehouseFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--  /* 是否使用了智能仓储管理技术（附件） */ smartWarehouseFiles-->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.SmartWarehouseFile')" label-width="420px"
            v-if="cooperationForm.smartWarehouseFlag == '1'" prop="smartWarehouseFiles">
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.smartWarehouseFiles" :on-progress="e => onProgress(e, 'SmartWarehouseFile')"
              :on-change="(file, fileList) =>
                  handleFileChange(file, fileList, 'SmartWarehouseFile')
                " multiple accept=".png,.jpg,.jpeg,.gif,.webp,.pdf,.doc,.docx" :before-upload="file => beforeAvatarUpload(file, 'SmartWarehouseFile')
                " :on-success="res => onSuccess(res, 'SmartWarehouseFile')" :on-error="(err, file, fileList) =>
                  onError(err, file, fileList, 'SmartWarehouseFile')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>

            <!-- 自定义文件列表表格 - 绿色工厂 -->
            <el-table v-if="cooperationForm.smartWarehouseFiles.length > 0" :data="cooperationForm.smartWarehouseFiles"
              style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'SmartWarehouseFile')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="deleteFile(scope.$index, 'SmartWarehouseFile')">{{
                    $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <!-- 绿色包装 -->
          <!-- /* 是否使用了绿色包装管理技术（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenPackaging')" label-width="420px"
            prop="greenPackageFlag">
            <!-- 是否Smart Warehouse -->
            <el-radio-group v-model="cooperationForm.greenPackageFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- /* 是否使用了绿色包装管理技术（附件） */ greenPackageFiles -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenPackagingFile')" label-width="420px"
            v-if="cooperationForm.greenPackageFlag == '1'" prop="greenPackageFiles">
            <!-- 上传对应的【绿色工厂认证证书/铭牌】附件 -->
            <!-- 绿色工厂上传 -->
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.greenPackageFiles" :on-progress="e => onProgress(e, 'isGreenPackagingFile')"
              :on-change="(file, fileList) =>
                  handleFileChange(file, fileList, 'isGreenPackagingFile')
                " multiple accept=".pdf,.doc,.docx" :before-upload="file => beforeAvatarUpload(file, 'isGreenPackagingFile')
                " :on-success="res => onSuccess(res, 'isGreenPackagingFile')" :on-error="(err, file, fileList) =>
                  onError(err, file, fileList, 'isGreenPackagingFile')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>

            <!-- 自定义文件列表表格 - 绿色工厂 -->
            <el-table v-if="cooperationForm.greenPackageFiles.length > 0" :data="cooperationForm.greenPackageFiles"
              style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'isGreenPackagingFile')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="deleteFile(scope.$index, 'isGreenPackagingFile')">{{
                    $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <!-- 绿色运输方式 -->
          <!--  /* 是否对产品使用新能源车辆进行运输（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenTransportationMode')
            " label-width="420px" prop="greenTransportationFlag">
            <!-- 是否对产品使用新能源车辆进行运输 -->
            <el-radio-group v-model="cooperationForm.greenTransportationFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 新能源车辆运输占比 -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isGreenTransportationModeRating'
          )
            " label-width="420px" v-if="cooperationForm.greenTransportationFlag == '1'"
            prop="greenTransportationValue">
            <el-input v-model="cooperationForm.greenTransportationValue" :placeholder="$t(
              'page.greenLowCarbon.contentLabel.isGreenTransportationModeRatingPlaceholder'
            )
              " style="width: 200px;"></el-input><span>%</span>
          </el-form-item>
          <!-- /* 是否对产品使用新能源车辆进行运输（附件） */ greenTransportationFiles-->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isGreenTransportationModeFile'
          )
            " label-width="420px" v-if="cooperationForm.greenTransportationFlag == '1'"
            prop="greenTransportationFiles">
            <!-- 上传对应的【绿色物流运输方案】附件 -->
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.greenTransportationFiles"
              :on-progress="e => onProgress(e, 'isGreenTransportationModeFile')" :on-change="(file, fileList) =>
                  handleFileChange(
                    file,
                    fileList,
                    'isGreenTransportationModeFile'
                  )
                " multiple accept=".png,.jpg,.jpeg,.gif,.webp,.pdf," :before-upload="file =>
                  beforeAvatarUpload(file, 'isGreenTransportationModeFile')
                " :on-success="res => onSuccess(res, 'isGreenTransportationModeFile')
                " :on-error="(err, file, fileList) =>
                  onError(err, file, fileList, 'isGreenTransportationModeFile')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>

            <!-- 自定义文件列表表格 - 绿色工厂 -->
            <el-table v-if="cooperationForm.greenTransportationFiles.length > 0"
              :data="cooperationForm.greenTransportationFiles" style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="
                    previewFile(scope.row, 'isGreenTransportationModeFile')
                    ">{{ $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="
                    deleteFile(scope.$index, 'isGreenTransportationModeFile')
                    ">{{ $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <!-- 碳管理 -->
          <el-card-title :title="title4" />
          <!-- 碳管理制度规划 -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isTopLevelCarbonManagement')
            " label-width="420px" prop="carbonManageFlag">
            <!-- 是否Smart Warehouse -->
            <el-radio-group v-model="cooperationForm.carbonManageFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--  /* 是否制定顶层碳管理制度规划（附件） */ carbonManageFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isTopLevelCarbonManagementFile'
          )
            " label-width="420px" v-if="cooperationForm.carbonManageFlag == '1'" prop="carbonManageFiles">
            <!-- 上传对应的【绿色工厂认证证书/铭牌】附件 -->
            <!-- 绿色工厂上传 -->
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.carbonManageFiles" :on-progress="e => onProgress(e, 'isTopLevelCarbonManagementFile')
                " multiple :on-change="(file, fileList) =>
                  handleFileChange(
                    file,
                    fileList,
                    'isTopLevelCarbonManagementFile'
                  )
                " accept=".pdf,.doc,.docx" :before-upload="file =>
                  beforeAvatarUpload(file, 'isTopLevelCarbonManagementFile')
                " :on-success="res => onSuccess(res, 'isTopLevelCarbonManagementFile')
                " :on-error="(err, file, fileList) =>
                  onError(err, file, fileList, 'isTopLevelCarbonManagementFile')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>

            <!-- 自定义文件列表表格 - 绿色工厂 -->
            <el-table v-if="cooperationForm.carbonManageFiles.length > 0" :data="cooperationForm.carbonManageFiles"
              style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="
                    previewFile(scope.row, 'isTopLevelCarbonManagementFile')
                    ">{{ $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="
                    deleteFile(scope.$index, 'isTopLevelCarbonManagementFile')
                    ">{{ $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <!-- 碳减排措施 -->
          <!-- /* 是否使用碳减排措施实现主体减排降碳（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isCarbonEmissionReductionMeasures'
          )
            " label-width="420px" prop="carbonEmissionFlag">
            <el-radio-group v-model="cooperationForm.carbonEmissionFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- /* 是否使用碳减排措施实现主体减排降碳（附件） */ carbonEmissionFiles-->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isCarbonEmissionReductionMeasuresFile'
          )
            " label-width="420px" v-if="cooperationForm.carbonEmissionFlag == '1'" prop="carbonEmissionFiles">
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.carbonEmissionFiles" :on-progress="e => onProgress(e, 'isCarbonEmissionReductionMeasuresFile')
                " multiple :on-change="(file, fileList) =>
                  handleFileChange(
                    file,
                    fileList,
                    'isCarbonEmissionReductionMeasuresFile'
                  )
                " accept=".pdf,.doc,.docx,.xlsx,xls" :before-upload="file =>
                  beforeAvatarUpload(
                    file,
                    'isCarbonEmissionReductionMeasuresFile'
                  )
                " :on-success="res => onSuccess(res, 'isCarbonEmissionReductionMeasuresFile')
                " :on-error="(err, file, fileList) =>
                  onError(
                    err,
                    file,
                    fileList,
                    'isCarbonEmissionReductionMeasuresFile'
                  )
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>

            <!-- 自定义文件列表表格 - 绿色工厂 -->
            <el-table v-if="cooperationForm.carbonEmissionFiles.length > 0" :data="cooperationForm.carbonEmissionFiles"
              style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="
                    previewFile(
                      scope.row,
                      'isCarbonEmissionReductionMeasuresFile'
                    )
                    ">{{ $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="
                    deleteFile(
                      scope.$index,
                      'isCarbonEmissionReductionMeasuresFile'
                    )
                    ">{{ $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <!-- 碳抵消手段 -->
          <!-- /* 是否使用碳抵消措施实现主体减排降碳（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isCarbonOffsetMeasures')
            " label-width="420px" prop="carbonOffsetFlag">
            <!-- 是否使用碳减排措施实现主体减排降碳 -->
            <el-radio-group v-model="cooperationForm.carbonOffsetFlag">
              <el-radio label="1">{{
                $t("page.greenLowCarbon.contentLabel.isYes")
                }}</el-radio>
              <el-radio label="0">{{
                $t("page.greenLowCarbon.contentLabel.isNo")
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- /* 是否使用碳抵消措施实现主体减排降碳（附件） */ carbonOffsetFiles -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isCarbonOffsetMeasuresFile')
            " label-width="420px" v-if="cooperationForm.carbonOffsetFlag == '1'" prop="carbonOffsetFiles">
            <!-- 上传相关的【碳减排措施应用清单/新能源采购记录】附件 -->
            <el-upload :action="uploadUrl" :show-file-list="false" class="upload-demo tow"
              :file-list="cooperationForm.carbonOffsetFiles" :on-progress="e => onProgress(e, 'carbonOffsetFiles')"
              :on-change="(file, fileList) =>
                  handleFileChange(file, fileList, 'carbonOffsetFiles')
                " multiple accept=".pdf,.doc,.docx,.xlsx,xls" :before-upload="file => beforeAvatarUpload(file, 'carbonOffsetFiles')
                " :on-success="res => onSuccess(res, 'carbonOffsetFiles')" :on-error="(err, file, fileList) =>
                  onError(err, file, fileList, 'carbonOffsetFiles')
                ">
              <el-button type="text" @click="getIndex()">{{
                $t("page.qualificationFile.btn.uploading")
                }}</el-button>
            </el-upload>

            <!-- 自定义文件列表表格 - 绿色工厂 -->
            <el-table v-if="cooperationForm.carbonOffsetFiles.length > 0" :data="cooperationForm.carbonOffsetFiles"
              style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'carbonOffsetFiles')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                  <el-button type="text" @click="deleteFile(scope.$index, 'carbonOffsetFiles')">{{
                    $t("page.greenLowCarbon.table.delete") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div class="btnBox">
      <el-button class="left-btn btn" size="mini" type="primary-icon-medium" @click="back()">
        <span>{{ $t("basicLayout.btn")[0] }}</span>
      </el-button>
      <el-button class="right-btn btn" size="mini" type="primary-icon-medium" @click="next()">
        <span>{{ $t("basicLayout.btn")[1] }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  saveSupplierRegistInfo,
  qrySupRegistHisPerform,
  qrySupRegistBaseInfo,
  qryGreenCarbonInfo,
  qrySmpcSysDictListByType
} from "@/api/supRegister";
import { mapActions } from "vuex";
import Cookies from "js-cookie";
import { Loading } from "ccui";
import { getPreviewUrl } from "@/utils";
import addGreenProducts from "./addGreenProducts";

export default {
  name: "historyCooperation",
  components: { addGreenProducts },
  data() {
    let baseUrl = this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    return {
      title: window.$t("page.greenLowCarbon.contentTitle.greenLowCarbon"), // 绿色低碳
      changeCategoryOption: [], // 选择类别
      greenFactoryCertificationLevelOption: [], // 绿色工厂认证等级
      logisticsCertificationLevelOption: [], // 绿色物流认证星级
      isGreenProductionRatingOption: [], // 绿色工厂认证等级
      zeroCarbonFactoryCertificationRatingOption: [], // 零碳工厂认证星级
      title1: window.$t("page.greenLowCarbon.contentTitle.greenProduction"), // 绿色生产,
      title2: window.$t("page.greenLowCarbon.contentTitle.greenProducts"), // 绿色产品,
      title3: window.$t("page.greenLowCarbon.contentTitle.greenLogistics"), // 绿色物流,
      title4: window.$t("page.greenLowCarbon.contentTitle.carbonManagement"), // 碳管理,
      greenFactoryFiles: [], //上传对应的【绿色工厂认证证书/铭牌】附件
      zeroFactoryFiles: [], //上传对应的【零碳工厂认证证书/铭牌】附件
      cleanProductionFiles: [], //上传的【清洁生产审核报告（备案本）】附件
      cementCraftFiles: [], //上传对应的【生产工艺设计说明/流程说明】附件
      steelEnergyConsumptionFiles: [], //上传对应的【单位产品能源消耗计算书】附件
      asphaltEnergyConsumptionFiles: [], //上传对应的【单位产品能源消耗计算书】附件
      cementRecyclingFiles: [], //上传对应的【生产原料替代率计算书】附件
      steelRecyclingFiles: [], //上传对应的【废钢循环利用方案、计算书】附件
      asphaltRecyclingFiles: [], //上传对应的【原材料回收利用率计算书】附件
      asphaltWasteRecyclingFiles: [], //上传对应的【回收利用退税证明文件/回收利用率计算书等】附件
      logisticsCertificationFiles: [], //上传对应的【绿色物流认证证书】附件
      smartWarehouseFiles: [], //上传使用的【节能措施技术清单/设备清单】附件
      greenPackageFiles: [], //上传对应的【绿色包装方案】附件
      greenTransportationFiles: [], //上传对应的【绿色物流运输方案】附件
      carbonManageFiles: [], //上传相关的【碳管理制度规划】附件
      carbonEmissionFiles: [], //上传相关的【碳减排措施应用清单/新能源采购记录】附件
      carbonOffsetFiles: [], //上传对应的【碳抵消产品购买证书】附件

      // {{$t('page.greenLowCarbon.table.preview')}}相关
      previewVisible: false,
      previewUrl: "",
      previewTitle: "",
      currentFileType: "",
      currentFileList: [], // 当前操作的文件列表引用
      // 表单数据
      cooperationForm: {
        greenCarbonManageFlag: "0", //  /* 企业是否设计绿色低碳管理：0 - 否；1 - 是 */,
        greenCarbonType:
          "" /* 绿色低碳类型：1 - 不选择；2 - 水泥；3 - 钢材；4 - 沥青 */,
        greenFactoryFlag: "0" /* 是否获得绿色工厂认证（1 - 是/0 - 否） */,
        greenFactoryLevel:
          "" /* 绿色工厂认证级别：7 - 市级；8 - 省级；9 - 国家级 */,
        // /* 绿色物流认证级别：1 - 一星；2 - 二星；3 - 三星 */
        logisticsCertificationLevel: "",
        // /* 绿色工厂认证证书 */
        greenFactoryFiles: [],
        zeroFactoryFlag: "0" /* 是否获得零碳工厂认证（1 - 是/0 - 否） */,
        zeroFactoryLevel:
          "" /* 零碳工厂认证级别：3 - 三星；4 - 四星；5 - 五星；6 - 六星 */,
        zeroFactoryFiles: [],
        /* 清洁生产审核报告（备案本） */
        cleanProductionFiles: [],
        //  /* 是否通过企业清洁生产审核（1 - 是/0 - 否） */
        cleanProductionFlag: "0",
        /* 水泥 - 是否使用新型干法等环保性生产工艺（1 - 是/0 - 否） */
        cementCraftFlag: "0",
        /* 水泥 - 是否采用原材料替代等资源循环利用方式（1 - 是/0 - 否） */
        cementRecyclingFlag: "0",
        /* 钢材 - 是否对轧钢过程进行废钢余料回收再利用（1 - 是/0 - 否） */
        steelRecyclingFlag: "0",
        /* 沥青 - 是否对沥青生产原材料进行回收利用（1 - 是/0 - 否） */
        asphaltRecyclingFlag: "0",
        // /* 沥青 - 是否对废沥青生产原材料进行回收利用（1 - 是/0 - 否） */
        asphaltWasteRecyclingFlag: "0",
        // /* 是否获得绿色物流认证（1 - 是/0 - 否） */
        logisticsCertificationFlag: "0",
        /* 是否对产品使用新能源车辆进行运输（1 - 是/0 - 否） */
        greenTransportationFlag: "0",
        /* 新能源运输占比（百分比） */
        greenTransportationValue: "",
        //     /* 是否使用了绿色包装管理技术（1 - 是/0 - 否） */
        greenPackageFlag: "0",
        /* 是否制定顶层碳管理制度规划（1 - 是/0 - 否） */
        carbonManageFlag: "0",
        /* 是否使用碳减排措施实现主体减排降碳（1 - 是/0 - 否） */
        carbonEmissionFlag: "0",
        /* 是否使用碳抵消措施实现主体减排降碳（1 - 是/0 - 否） */
        carbonOffsetFlag: "0",
        /* 是否使用了智能仓储管理技术（1 - 是/0 - 否） */
        smartWarehouseFlag: "0",
        /* 水泥 - 原材料替代率（百分比） */
        cementRecyclingValue: "",
        /* 钢材 - 单位产品能源消耗量 */
        steelEnergyConsumptionValue: "",
        /* 沥青 - 单位产品能源消耗量 */
        asphaltEnergyConsumptionValue: "",
        cementCraftFiles: [], //上传对应的【生产工艺设计说明/流程说明】附件
        steelEnergyConsumptionFiles: [], //上传对应的【单位产品能源消耗计算书】附件
        asphaltEnergyConsumptionFiles: [], //上传对应的【单位产品能源消耗计算书】附件
        cementRecyclingFiles: [], //上传对应的【生产原料替代率计算书】附件
        steelRecyclingFiles: [], //上传对应的【废钢循环利用方案、计算书】附件
        asphaltRecyclingFiles: [], //上传对应的【原材料回收利用率计算书】附件
        asphaltWasteRecyclingFiles: [], //上传对应的【回收利用退税证明文件/回收利用率计算书等】附件
        logisticsCertificationFiles: [], //上传对应的【绿色物流认证证书】附件
        smartWarehouseFiles: [], //上传使用的【节能措施技术清单/设备清单】附件
        greenPackageFiles: [], //上传对应的【绿色包装方案】附件
        greenTransportationFiles: [], //上传对应的【绿色物流运输方案】附件
        carbonManageFiles: [], //上传相关的【碳管理制度规划】附件
        carbonEmissionFiles: [], //上传相关的【碳减排措施应用清单/新能源采购记录】附件
        carbonOffsetFiles: [] //上传对应的【碳抵消产品购买证书】附件
      },
      // 表单校验规则
      cooperationFormRules: {
        // 企业是否设计绿色低碳管理
        greenCarbonManageFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.cooperationCompanyMsg"
            ),
            trigger: "change"
          }
        ],
        // 绿色低碳类型 1 - 不选择；2 - 水泥；3 - 钢材；4 - 沥青 */
        greenCarbonType: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.changeCategoryMsg"
            ),
            trigger: "change"
          }
        ],
        /* 是否获得绿色工厂认证（1 - 是/0 - 否） */
        greenFactoryFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isGreenProductionMsg"
            ),
            trigger: "change"
          }
        ],
        /* 绿色工厂认证级别：7 - 市级；8 - 省级；9 - 国家级 */
        greenFactoryLevel: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.greenFactoryCertificationLevelPlaceholderMsg"
            ),
            trigger: "change"
          }
        ],
        /* 绿色物流认证级别：1 - 一星；2 - 二星；3 - 三星 */
        logisticsCertificationLevel: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isGreenProductionRating"
            ),
            trigger: "change"
          }
        ],
        /* 绿色工厂认证证书 */
        greenFactoryFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.greenFactoryCertificationFileMsg"
                    )
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        /* 是否获得零碳工厂认证（1 - 是/0 - 否） */
        zeroFactoryFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isZeroCarbonFactoryCertificationMsg"
            ),
            trigger: "change"
          }
        ],
        /* 零碳工厂认证级别：3 - 三星；4 - 四星；5 - 五星；6 - 六星 */
        zeroFactoryLevel: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isZeroCarbonFactoryCertificationRatingMsg"
            ),
            trigger: "change"
          }
        ],
        zeroFactoryFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.ZeroCarbonFactoryCertificationRatingFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        /* 是否通过企业清洁生产审核（1 - 是/0 - 否） */
        cleanProductionFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isEnterprisesPassTheCleanProductionAuditMsg"
            ),
            trigger: "change"
          }
        ],
        /* 清洁生产审核报告（备案本） */
        cleanProductionFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.EnterprisesPassTheCleanProductionAuditFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        cementCraftFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isEnvironmentallyFriendlyProductionProcessMsg"
            ),
            trigger: "change"
          }
        ],
        cementCraftFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.EnvironmentallyFriendlyProductionProcessFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        /* 钢材 - 单位产品能源消耗量 */
        steelEnergyConsumptionValue: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isProductEnergyConsumptionMsg"
            ),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              const str = String(value);
              if (str.length > 20) {
                callback(new Error("最多输入20位字符"));
                return;
              }
              const numPattern = /^\d+(\.\d{1,2})?$/;
              if (!numPattern.test(str)) {
                callback(new Error("只能输入大于0的数字，最多保留两位小数"));
                return;
              }
              const num = parseFloat(str);
              if (num <= 0) {
                callback(new Error("只能输入大于0的数字"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        steelEnergyConsumptionFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.ProductEnergyConsumptionFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        /* 沥青 - 单位产品能源消耗量 */
        asphaltEnergyConsumptionValue: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isAsphaltProductEnergyConsumptionMsg"
            ),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              const str = String(value);
              if (str.length > 20) {
                callback(new Error("最多输入20位字符"));
                return;
              }
              const numPattern = /^\d+(\.\d{1,2})?$/;
              if (!numPattern.test(str)) {
                callback(new Error("只能输入大于0的数字，最多保留两位小数"));
                return;
              }
              const num = parseFloat(str);
              if (num <= 0) {
                callback(new Error("只能输入大于0的数字"));
                return;
              }
              callback();
            },
            trigger: "blur",
          }
        ],
        asphaltEnergyConsumptionFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.AsphaltProductEnergyConsumptionFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        /* 水泥 - 是否采用原材料替代等资源循环利用方式（1 - 是/0 - 否） */
        cementRecyclingFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.AdoptingMethodsOfResourceRecyclingSuchAsRawMaterialSubstitutionMsg"
            ),
            trigger: "change"
          }
        ],
        /* 水泥 - 原材料替代率（百分比） */
        cementRecyclingValue: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.RawMaterialSubstitutionRateMsg"
            ),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              const str = String(value);
              if (str.length > 10) {
                callback(new Error("最多输入10位字符"));
                return;
              }
              const numPattern = /^\d+(\.\d{1,2})?$/;
              if (!numPattern.test(str)) {
                callback(new Error("只能输入大于0的数字，最多保留两位小数"));
                return;
              }
              const num = parseFloat(str);
              if (num <= 0) {
                callback(new Error("只能输入大于0的数字"));
                return;
              }
              callback();
            },
            trigger: "blur",
          }
        ],
        cementRecyclingFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.productionRawMaterialSubstitutionRate"
                    )
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        steelRecyclingFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.ScrapSteelRecyclingPlanFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        /* 沥青 - 是否对沥青生产原材料进行回收利用（1 - 是/0 - 否） */
        asphaltRecyclingFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.IsRecyclingOfRawMaterialsForAsphaltProductionConducted"
            ),
            trigger: "change"
          }
        ],
        /* 沥青 - 原材料回收利用率（百分比） */
        asphaltRecyclingValue: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.RawMaterialRecyclingAndUtilizationRate"
            ),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              const str = String(value);
              if (str.length > 10) {
                callback(new Error("最多输入10位字符"));
                return;
              }
              const numPattern = /^\d+(\.\d{1,2})?$/;
              if (!numPattern.test(str)) {
                callback(new Error("只能输入大于0的数字，最多保留两位小数"));
                return;
              }
              const num = parseFloat(str);
              if (num <= 0) {
                callback(new Error("只能输入大于0的数字"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        // /* 沥青 - 是否对废沥青生产原材料进行回收利用（1 - 是/0 - 否） */
        asphaltWasteRecyclingFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.IsWasteAsphaltRecycledAndReused"
            ),
            trigger: "change"
          }
        ],
        asphaltWasteRecyclingFiles: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.recyclingTaxRefundSupportingDocuments"
            ),
            trigger: "change"
          }
        ],
        asphaltRecyclingFiles: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.CalculationSheetForRawMaterialRecyclingUtilizationRate"
            ),
            trigger: "change"
          }
        ],
        /* 沥青 - 废沥青原材料回收利用率（百分比） */
        asphaltWasteRecyclingValue: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.RecyclingRateOfWasteAsphalt"
            ),
            trigger: "change"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              const str = String(value);
              if (str.length > 10) {
                callback(new Error("最多输入10位字符"));
                return;
              }
              const numPattern = /^\d+(\.\d{1,2})?$/;
              if (!numPattern.test(str)) {
                callback(new Error("只能输入大于0的数字，最多保留两位小数"));
                return;
              }
              const num = parseFloat(str);
              if (num <= 0) {
                callback(new Error("只能输入大于0的数字"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        logisticsCertificationFlag: [
          {
            required: true,
            message: window.$t("page.greenLowCarbon.inputPlc.isGreenLogistics"),
            trigger: "change"
          }
        ],
        greenTransportationFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isGreenTransportationMode"
            ),
            trigger: "change"
          }
        ],
        /* 新能源运输占比（百分比） */
        greenTransportationValue: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isGreenTransportationModeRating"
            ),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              const str = String(value);
              if (str.length > 10) {
                callback(new Error("最多输入10位字符"));
                return;
              }
              const numPattern = /^\d+(\.\d{1,2})?$/;
              if (!numPattern.test(str)) {
                callback(new Error("只能输入大于0的数字，最多保留两位小数"));
                return;
              }
              const num = parseFloat(str);
              if (num <= 0) {
                callback(new Error("只能输入大于0的数字"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        /* 是否使用了智能仓储管理技术（1 - 是/0 - 否） */
        smartWarehouseFlag: [
          {
            required: true,
            message: window.$t("page.greenLowCarbon.inputPlc.isSmartWarehouse"),
            trigger: "change"
          }
        ],
        logisticsCertificationFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t("page.greenLowCarbon.inputPlc.greenLogisticsFile")
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        greenTransportationFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.isGreenTransportationModeFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        smartWarehouseFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t("page.greenLowCarbon.inputPlc.SmartWarehouseFile")
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        greenPackageFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.isGreenPackagingFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        /* 是否使用了绿色包装管理技术（1 - 是/0 - 否） */
        greenPackageFlag: [
          {
            required: true,
            message: window.$t("page.greenLowCarbon.inputPlc.isGreenPackaging"),
            trigger: "change"
          }
        ],

        carbonManageFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.isTopLevelCarbonManagementFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        /* 是否制定顶层碳管理制度规划（1 - 是/0 - 否） */
        carbonManageFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isTopLevelCarbonManagement"
            ),
            trigger: "change"
          }
        ],
        carbonEmissionFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.isCarbonEmissionReductionMeasuresFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        carbonEmissionFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isCarbonEmissionReductionMeasures"
            ),
            trigger: "change"
          }
        ],
        carbonOffsetFiles: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 多文件时验证数组长度
              if (!value || value.length === 0) {
                callback(
                  new Error(
                    window.$t(
                      "page.greenLowCarbon.inputPlc.isCarbonOffsetMeasuresFile"
                    )
                  )
                );
              } else {
                callback();
              }
            },

            trigger: "change"
          }
        ],
        /* 是否使用碳抵消措施实现主体减排降碳（1 - 是/0 - 否） */
        carbonOffsetFlag: [
          {
            required: true,
            message: window.$t(
              "page.greenLowCarbon.inputPlc.isCarbonOffsetMeasures"
            ),
            trigger: "change"
          }
        ]
      },
      tableData: [],
      supInfoApplyId: "",
      uploadUrl: baseUrl + "/apis/sra/oss/users/signup/uploadFilePersNew", //上传图片
      uploadLoading: null,

      // 上传配置映射表
      uploadConfig: {
        green: {
          fileList: "greenFactoryFiles",
          fieldName: "greenFactoryFiles"
        },
        zero: {
          fileList: "zeroFactoryFiles",
          fieldName: "zeroFactoryFiles"
        },
        clean: {
          fileList: "cleanProductionFiles",
          fieldName: "cleanProductionFiles"
        },
        production: {
          fileList: "cementCraftFiles",
          fieldName: "cementCraftFiles"
        },
        energy: {
          fileList: "steelEnergyConsumptionFiles",
          fieldName: "steelEnergyConsumptionFiles"
        },
        Asphalt: {
          fileList: "asphaltEnergyConsumptionFiles",
          fieldName: "asphaltEnergyConsumptionFiles"
        },
        Calculation: {
          fileList: "cementRecyclingFiles",
          fieldName: "cementRecyclingFiles"
        },
        steelRollingProcess: {
          fileList: "steelRecyclingFiles",
          fieldName: "steelRecyclingFiles"
        },
        CalculationSheet: {
          fileList: "asphaltRecyclingFiles",
          fieldName: "asphaltRecyclingFiles"
        },
        recyclingTax: {
          fileList: "asphaltWasteRecyclingFiles",
          fieldName: "asphaltWasteRecyclingFiles"
        },
        greenLogisticsFile: {
          fileList: "logisticsCertificationFiles",
          fieldName: "logisticsCertificationFiles"
        },
        SmartWarehouseFile: {
          fileList: "smartWarehouseFiles",
          fieldName: "smartWarehouseFiles"
        },
        isGreenPackagingFile: {
          fileList: "greenPackageFiles",
          fieldName: "greenPackageFiles"
        },
        isGreenTransportationModeFile: {
          fileList: "greenTransportationFiles",
          fieldName: "greenTransportationFiles"
        },
        isCarbonEmissionReductionMeasuresFile: {
          fileList: "carbonEmissionFiles",
          fieldName: "carbonEmissionFiles"
        },
        isTopLevelCarbonManagementFile: {
          fileList: "carbonManageFiles",
          fieldName: "carbonManageFiles"
        },
        carbonOffsetFiles: {
          fileList: "carbonOffsetFiles",
          fieldName: "carbonOffsetFiles"
        }
      },
      // 预览相关
      previewVisible: false,
      previewUrl: "",
      previewTitle: "",
      isImage: false,
      isPdf: false,
      isGAT: false,
      supInfoId: "",
      supCode: "",
      temGreenInfo: [],
      isChinese: Cookies.get("language")
    };
  },
  created() {
    if (this.$route.query.page) {
      this.changeCheckPage(9);
    }
    if (Cookies.get("access_token") || this.$route.query.tempSupinfoId) {
      // this.getSupRegistHisPerform();
      this.getSupRegistBaseInfo();
    }
    if (this.$route.path == "/maPerfectInfo/greenLowCarbon") {
      this.changeCheckPage(9);
      for (let i = 0; i < 5; i++) {
        this.msgCenter.$emit("ballMoveRight");
      }
    }
    // 供应商绿色类型
    qrySmpcSysDictListByType({ dictType: "SUP_GREEN_TYPE" }).then(res => {
      if (res.data.code == 0) {
        this.changeCategoryOption = res.data.data;
      }
    });
    // 供应商通用绿色工厂-等级
    qrySmpcSysDictListByType({
      dictType: "SUP_GREEN_TYPE_PRODUCTION_FACTORY"
    }).then(res => {
      if (res.data.code == 0) {
        this.greenFactoryCertificationLevelOption = res.data.data;
      }
    });
    // 供应商通用零碳工厂-等级
    qrySmpcSysDictListByType({
      dictType: "SUP_GREEN_TYPE_PRODUCTION_CARBON"
    }).then(res => {
      if (res.data.code == 0) {
        this.zeroCarbonFactoryCertificationRatingOption = res.data.data;
      }
    });
    // 供应商通用零碳工厂-等级
    qrySmpcSysDictListByType({
      dictType: "SUP_GREEN_TYPE_CERTIFICATION"
    }).then(res => {
      if (res.data.code == 0) {
        this.logisticsCertificationLevelOption = res.data.data;
      }
    });
  },

  methods: {
    ...mapActions(["changeCheckPage"]),
    back() {
      this.changeCheckPage(9);
      if(this.isChinese === 'zh-cn') {
        this.$router.push({path:'/maPerfectInfo/historyCooperation',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
      } else {
        this.$router.push({path:'/maPerfectInfo/financialInformation',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
      }

    },
    // 校验表格数据
    validateTableData() {
      let productData = this.cooperationForm.greenProductList;
      if (productData.length === 0) {
        this.$message.warning(`第1行 请填写 产品名称 `);
        return false;
      }
      for (let i = 0; i < productData.length; i++) {
        const row = productData[i];
        const rowNum = i + 1;

        // 校验产品名称
        if (!row.productName) {
          this.$message.warning(`第${rowNum}行 请填写 产品名称 `);
          return false;
        }

        // 如果是绿色产品认证
        if (row.greenCertificationFlag === "1") {
          // 校验绿色产品认证星级
          if (!row.greenCertificationLevel) {
            this.$message.warning(`第${rowNum}行 请选择 绿色产品认证星级 `);
            return false;
          }

          // 校验附件是否上传
          if (
            !row.greenCertificationFiles ||
            row.greenCertificationFiles.length === 0
          ) {
            this.$message.warning(
              `第${rowNum}行 请上传对应的【绿色产品认证证书/绿色产品标识】附件`
            );
            return false;
          }
        } else {
          row.greenCertificationLevel = ""
          row.greenCertificationFiles = []
        }
        // 如果是绿色产品认证
        if (row.carbonFootstepFlag === "1") {
          // 校验绿色产品认证星级
          if (!row.carbonFootstepValue) {
            this.$message.warning(`第${rowNum}行 产品碳足迹数值 未填写`);
            return false;
          }

          // 校验附件是否上传
          if (
            !row.carbonFootstepFiles ||
            row.carbonFootstepFiles.length === 0
          ) {
            this.$message.warning(
              `第${rowNum}行 请上传对应的【产品碳足迹证书】或【产品碳足迹报告】附件`
            );
            return false;
          }
        } else {
          row.carbonFootstepValue = ""
          row.carbonFootstepFiles = []
        }
      }
      return true;
    },
    cleanFormData(formData) {
      const flagFieldMapping = {
        greenFactoryFlag: {
          files: "greenFactoryFiles",
          level: "greenFactoryLevel",
          value: null
        },
        zeroFactoryFlag: {
          files: "zeroFactoryFiles",
          level: "zeroFactoryLevel",
          value: null
        },
        cleanProductionFlag: {
          files: "cleanProductionFiles",
          level: null,
          value: null
        },
        production: {
          files: "cementCraftFiles",
          level: null,
          value: null
        },
        cementRecyclingFlag: {
          files: "cementRecyclingFiles",
          level: null,
          value: "cementRecyclingValue"
        },
        steelRecyclingFlag: {
          files: "steelRecyclingFiles",
          level: null,
          value: null
        },
        asphaltRecyclingFlag: {
          files: "asphaltRecyclingFiles",
          level: null,
          value: "asphaltRecyclingValue"
        },
        asphaltWasteRecyclingFlag: {
          files: "asphaltWasteRecyclingFiles",
          level: null,
          value: "asphaltWasteRecyclingValue"
        },
        logisticsCertificationFlag: {
          files: "logisticsCertificationFiles",
          level: "logisticsCertificationLevel",
          value: null
        },
        greenTransportationFlag: {
          files: "greenTransportationFiles",
          level: null,
          value: "greenTransportationValue"
        },
        greenPackageFlag: {
          files: "greenPackageFiles",
          level: null,
          value: null
        },
        carbonManageFlag: {
          files: "carbonManageFiles",
          level: null,
          value: null
        },
        carbonEmissionFlag: {
          files: "carbonEmissionFiles",
          level: null,
          value: null
        },
        carbonOffsetFlag: {
          files: "carbonOffsetFiles",
          level: null,
          value: null
        },
        smartWarehouseFlag: {
          files: "smartWarehouseFiles",
          level: null,
          value: null
        },
        steelEnergyConsumptionFlag: {
          files: "steelEnergyConsumptionFiles",
          level: null,
          value: "steelEnergyConsumptionValue"
        },
        asphaltEnergyConsumptionFlag: {
          files: "asphaltEnergyConsumptionFiles",
          level: null,
          value: "asphaltEnergyConsumptionValue"
        }
      };

      // ✅ 创建新对象，直接复制所有字段
      const cleanedData = {};

      // 复制所有原始字段
      Object.keys(formData).forEach(key => {
        cleanedData[key] = formData[key];
      });

      // 遍历映射关系，当 Flag 为 "0" 时清空对应字段
      Object.keys(flagFieldMapping).forEach(flagKey => {
        if (cleanedData[flagKey] === "0") {
          const mapping = flagFieldMapping[flagKey];

          // 清空 Files
          if (mapping.files && cleanedData[mapping.files] !== undefined) {
            cleanedData[mapping.files] = [];
          }

          // 清空 Level
          if (mapping.level && cleanedData[mapping.level] !== undefined) {
            cleanedData[mapping.level] = "";
          }

          // 清空 Value
          if (mapping.value && cleanedData[mapping.value] !== undefined) {
            cleanedData[mapping.value] = "";
          }
        }
      });

      // 特殊处理：greenCarbonManageFlag 为 "0" 时清空类型
      if (cleanedData.greenCarbonManageFlag === "0") {
        cleanedData.greenCarbonType = "";
      }

      // 确保 Flag 字段为字符串类型
      const flagFields = [
        "greenFactoryFlag", "zeroFactoryFlag", "cleanProductionFlag",
        "cementCraftFlag", "cementRecyclingFlag", "steelRecyclingFlag",
        "asphaltRecyclingFlag", "asphaltWasteRecyclingFlag",
        "logisticsCertificationFlag", "greenTransportationFlag",
        "greenPackageFlag", "carbonManageFlag", "carbonEmissionFlag",
        "carbonOffsetFlag", "smartWarehouseFlag", "greenCarbonManageFlag"
      ];

      flagFields.forEach(field => {
        if (cleanedData[field] !== undefined && cleanedData[field] !== null) {
          cleanedData[field] = String(cleanedData[field]);
        }
      });

      // ✅ 返回完整对象
      return cleanedData;
    },
    next() {
      this.$refs.cooperationFormRef.validate(valid => {
        if (valid) {
          this.cooperationForm.tempSupinfoId = this.$route.query.tempSupinfoId;
          this.cooperationForm.supCode = this.supCode;
          // 先进行数据校验
          if(!this.isGAT && this.cooperationForm.greenCarbonManageFlag == '1'){
            if (!this.validateTableData() ) {
              return; // 校验不通过，阻止提交
            }
          }

          // 清洗数据
          const submitData = this.cleanFormData(this.cooperationForm);

          saveSupplierRegistInfo({
            dataSourceFlag: 0,
            isShowLoading: true,
            isOverseas: 0,
            tempSupinfoId: this.$route.query.tempSupinfoId,
            saveOrCommitFlag: "2",
            supRegistTab: "9-1",
            tempSupGreenInfoBO: submitData,
          }).then(res => {
            if (res.data.code === "0") {
              this.changeCheckPage(11);
              this.$router.push({
                path: "/maPerfectInfo/qualificationDocuments",
                query: { tempSupinfoId: this.$route.query.tempSupinfoId }
              });
            }
          });
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
        }
      });
    },
    handleGreenProduct(data) {
      data.forEach(item => {
        item.supCode = this.supCode;
        item.tempSupinfoId = this.$route.query.tempSupinfoId;
      });
      this.cooperationForm.greenProductList = data;
    },
    async getSupRegistBaseInfo() {
      try {
        const { data } = await qrySupRegistBaseInfo({
          tempOrFormalFlag: this.$route.query.tempOrFormalFlag
            ? this.$route.query.tempOrFormalFlag
            : 0,
          supInfoApplyId: this.$route.query.tempSupinfoId,
          isShowLoading: true
        });
        this.supInfoId = data.data.supInfoApplyId;
        this.supCode = data.data.supRegistAccountInfoBO.supCode;

        if (
          data.data.supRegistAccountInfoBO.locationCode == "970000" ||
          data.data.supRegistAccountInfoBO.isOverseas == 1 ||
          this.isChinese !== "zh-cn"
        ) {
          this.isGAT = true;
        } else {
          this.qryGreenCarbonInfo();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async qryGreenCarbonInfo() {
      try {
        const { data } = await qryGreenCarbonInfo({
          supInfoId: this.supInfoId,
          tempOrFormalFlag: 0,
          isShowLoading: true
        });

        console.log(data, "data");
        if (data.code == 0) {
          // 类型转换：将数值转为字符串
          const formData = data.data;

          // 需要转换的字段列表
          const flagFields = [
            "greenFactoryFlag",
            "zeroFactoryFlag",
            "cleanProductionFlag",
            "cementCraftFlag",
            "cementRecyclingFlag",
            "steelRecyclingFlag",
            "asphaltRecyclingFlag",
            "asphaltWasteRecyclingFlag",
            "logisticsCertificationFlag",
            "greenTransportationFlag",
            "greenPackageFlag",
            "carbonManageFlag",
            "carbonEmissionFlag",
            "carbonOffsetFlag",
            "smartWarehouseFlag",
            "greenCarbonManageFlag"
          ];

          flagFields.forEach(field => {
            if (formData[field] !== undefined && formData[field] !== null) {
              formData[field] = String(formData[field]);
            }
          });

          this.cooperationForm = formData;
          if (
            data.data.greenProductList &&
            data.data.greenProductList.length > 0
          ) {
            data.data.greenProductList.forEach(k => {
              k.greenCertificationFlag = String(k.greenCertificationFlag);
              k.carbonFootstepFlag = String(k.carbonFootstepFlag);
            });
            this.temGreenInfo = data.data.greenProductList;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getSupRegistHisPerform() {
      const { data } = await qrySupRegistHisPerform({
        tempOrFormalFlag: this.$route.query.tempOrFormalFlag
          ? this.$route.query.tempOrFormalFlag
          : 0,
        supInfoApplyId: this.$route.query.tempSupinfoId,
        isShowLoading: true
      });
      console.log(data);
      if (data.code === "0") {
        this.cooperationForm.cooperEnterprise =
          data.data.supRegistHisPerformBO.cooperEnterprise;
        this.cooperationForm.cooperPerformIccec =
          data.data.supRegistHisPerformBO.cooperPerformIccec;
        this.cooperationForm.cooperPerformSameInd =
          data.data.supRegistHisPerformBO.cooperPerformSameInd;
        this.cooperationForm.remark = data.data.supRegistHisPerformBO.remark;
        this.supInfoApplyId = data.data.supInfoApplyId;
      }
    },

    getIndex() { },

    //预览
    async previewFile({ uploadId,uploadIdStr }) {
      if (uploadIdStr) {
        getPreviewUrl(uploadIdStr);
      }else{
        getPreviewUrl(uploadId);
      }
    },

    // 下载文件
    downloadFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/sra/reg/users/signup/downloadByFileUrl?fileUrl=${
        row.ossUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },

    // 删除文件
    deleteFile(index, type) {
      const config = this.uploadConfig[type];
      const fieldName = config.fieldName;
      this.$confirm("确定要删除该文件吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (config) {
            const fileList = this.cooperationForm[config.fileList];
            fileList.splice(index, 1);
            // 同步更新表单字段
            this.$set(this.cooperationForm, config.fileList, fileList);
          }

          // 重新触发验证
          this.$refs.cooperationFormRef.validateField(fieldName);

          this.$message.success("删除成功");
        })
        .catch(() => { });
    },
    // 文件变化处理
    handleFileChange(file, fileList, type) {
      let fieldName = "";
      let fileListName = "";
      switch (type) {
        case "green":
          fieldName = "greenFactoryFiles";
          fileListName = "greenFactoryFiles";
          break;
        case "zero":
          fieldName = "zeroFactoryFiles";
          fileListName = "zeroFactoryFiles";
          break;
        case "clean":
          fieldName = "cleanProductionFiles";
          fileListName = "cleanProductionFiles";
          break;
        case "production":
          fieldName = "cementCraftFiles";
          fileListName = "cementCraftFiles";
          break;
        case "energy":
          fieldName = "steelEnergyConsumptionFiles";
          fileListName = "steelEnergyConsumptionFiles";
          break;
        case "Asphalt":
          fieldName = "asphaltEnergyConsumptionFiles";
          fileListName = "asphaltEnergyConsumptionFiles";
          break;
        case "Calculation":
          fieldName = "cementRecyclingFiles";
          fileListName = "cementRecyclingFiles";
          break;
        case "steelRollingProcess":
          fieldName = "steelRecyclingFiles";
          fileListName = "steelRecyclingFiles";
          break;
        case "CalculationSheet":
          fieldName = "asphaltRecyclingFiles";
          fileListName = "asphaltRecyclingFiles";
          break;
        case "recyclingTax":
          fieldName = "asphaltWasteRecyclingFiles";
          fileListName = "asphaltWasteRecyclingFiles";
          break;
        case "greenLogisticsFile":
          fieldName = "logisticsCertificationFiles";
          fileListName = "logisticsCertificationFiles";
          break;
        case "SmartWarehouseFile":
          fieldName = "smartWarehouseFiles";
          fileListName = "smartWarehouseFiles";
          break;
        case "isGreenPackagingFile":
          fieldName = "greenPackageFiles";
          fileListName = "greenPackageFiles";
          break;
        case "isGreenTransportationModeFile":
          fieldName = "greenTransportationFiles";
          fileListName = "greenTransportationFiles";
          break;
        case "isCarbonEmissionReductionMeasuresFile":
          fieldName = "carbonEmissionFiles";
          fileListName = "carbonEmissionFiles";
          break;
        case "isTopLevelCarbonManagementFile":
          fieldName = "carbonManageFiles";
          fileListName = "carbonManageFiles";
          break;
        case "carbonOffsetFiles":
          fieldName = "carbonOffsetFiles";
          fileListName = "carbonOffsetFiles";
          break;

        default:
          break;
      }

      console.log(fileList);

      fileList.forEach(item => {
        if (item.response && item.response.data[0]) {
          item.fileUrl = item.response.data[0].downloadUrl;
          item.fileName = item.response.data[0].fileName;
          item.fileSize = Math.round(item.response.data[0].fileSize / 1024);
          item.uploadId = item.response.data[0].uploadId;
          item.ossUrl = item.response.data[0].ossUrl;
        }
      });
      // 更新表单字段
      if (file.status === "success") {
        this.cooperationForm[fileListName] = fileList;
      }

      // 触发验证
      this.$refs.cooperationFormRef.validateField(fieldName);
    },

    // 上传进度
    onProgress(progressEvent, type) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      if (progressEvent.percent > 90) {
        progressEvent.percent = 98;
      }
    },

    // 上传成功
    onSuccess(res, type) {
      this.uploadLoading.close();
      if (res.code === "0") {
        this.$message.success(window.$t("page.qualificationFile.info.upload1"));
      }

    },

    // 上传错误
    onError(err, file, fileList, type) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading.close();
    },

    // 上传前校验
    beforeAvatarUpload(file, type) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });

      let isUpload = true;
      let fileTypeLen = file.name.split(".");
      let imgType = [];
      if (
        type == "production" ||
        type == "carbonOffsetFiles" ||
        type == "isCarbonEmissionReductionMeasuresFile"
      ) {
        imgType = ["doc", "docx", "xls", "xlsx",  "pdf"];
      } else if (type == "energy") {
        imgType = [
          "doc",
          "docx",
          "jpg",
          "jpeg",
          "png",
          "gif",
          "webp",

          "pdf"
        ];
      } else if (
        type == "Asphalt" ||
        type == "isGreenPackagingFile" ||
        type == "isTopLevelCarbonManagementFile" ||
        type == "Calculation" ||  type=="steelRollingProcess" || type == "CalculationSheet" || type == "recyclingTax"
      ) {
        imgType = ["doc", "docx",  "pdf"];
      } else if (type == "SmartWarehouseFile") {
        imgType = [
          "jpg",
          "jpeg",
          "png",
          "gif",
          "webp",
          "doc",
          "docx",
          "xls",
          "xlsx",

          "pdf"
        ];
      } else {
        imgType = ["jpg", "jpeg", "png", "gif", "webp", "pdf"];
      }
      const isLt400k = file.size / 1024 / 1024 < 15;
      let isImg = imgType.includes(
        fileTypeLen[fileTypeLen.length - 1].toLowerCase()
      );

      if (!isImg) {
        this.uploadLoading.close();
        this.$message({
          type: "error",
          message: window.$t("page.greenLowCarbon.contentLabel.uploadErr1"),
          offset: document.body.clientHeight / 2 - 21
        });
        isUpload = false;
      } else if (!isLt400k) {
        this.uploadLoading.close();
        this.$message({
          type: "error",
          message: window.$t("page.greenLowCarbon.contentLabel.uploadErr2"),
          offset: document.body.clientHeight / 2 - 21
        });
        isUpload = false;
      }

      return isUpload;
    },
      // 切换绿色低碳类型时清除校验
  handleGreenCarbonTypeChange() {
    // 清除所有字段的校验状态
    this.$nextTick(() => {
      this.$refs.cooperationFormRef.clearValidate()
    })
  },
  }
};
</script>

<style scoped lang="scss">
.sign-content {
  width: 1180px;
  background: #ffffff;
  margin: 20px auto;
  overflow: hidden;

  .el-card-title {
    /deep/ .details-title {
      color: black;
      border-bottom: 0px;
      top: 20px;
      margin-left: 230px;
    }
  }

  .el-form {
    margin-top: 20px;
    //margin-left: 250px;
    position: relative;

    .el-textarea {
      margin-left: 6px;
      width: 430px;
      border-radius: 4px;

      /deep/ .el-textarea__inner {
        height: 58px;
      }
    }

    .upload-demo /deep/ .el-button {
      padding-top: 8px;
    }

    .el-table {
      width: 585px;
      margin: 40px auto;

      /deep/ .el-table__row {
        .el-input {
          input {
            background-color: #f1f1f1 !important;
            color: #9b9b9b !important;
          }
        }

        .cooperation .el-input__inner {
          padding-right: 60px;
        }
      }
    }

    .addbtn {
      position: absolute;
      left: 790px;

      /deep/ .icon-ccui-add {
        margin-right: 10px;
        color: #ff142f;
      }

      /deep/ span {
        color: #ff142f;
      }
    }
  }
}

.btn {
  width: 240px;
  height: 40px;
  background: #ff142f;
  margin-bottom: 20px;

  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}

.btnBox {
  margin: 0px auto;
  width: 500px;
}

.cooperationRuls {
  .el-form-item__error {
    width: 100%;
    text-align: center;
  }
}
</style>
